import { render } from "./EditDialog.vue?vue&type=template&id=19b74c51"
import script from "./EditDialog.vue?vue&type=script&lang=js"
export * from "./EditDialog.vue?vue&type=script&lang=js"

import "./EditDialog.vue?vue&type=style&index=0&id=19b74c51&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__